<div class="app-dialog">
    <h2 [innerHtml]="title"></h2>
    <div [innerHtml]="message" class="mt20"></div>
    <button (click)="closeDialog()" class="right mt30" mat-flat-button color="primary">OK</button>
</div>
